export enum DurationType {
	Horas = "Horas",
	Meses = "Meses",
	Semestres = "Semestres",
}

export const parseJwt = (token: any) => {
	const base64Url = token.split(".")[1];
	const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	const jsonPayload = decodeURIComponent(
		atob(base64)
			.split("")
			.map((c) => {
				return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
			})
			.join(""),
	);

	return JSON.parse(jsonPayload);
};

export const cashbackStatusLabels: { [key: string]: string } = {
	authorized: "Autorizado",
	canceled: "Cancelado",
	expired: "Expirado",
	null: "Cadastro Incompleto",
	paid: "Pago",
	pending: "Pendente",
	pending_refund: "Reembolso Pendente",
	processing: "Processando",
	refunded: "Reembolsado",
	refused: "Recusado",
	waiting_payment: "Pagamento pendente",
};

export const classShiftLabels: { [key: string]: string } = {
	EVENING: "Tarde",
	EVENING1: "Tarde 1",
	EVENING2: "Tarde 2",
	EVENING3: "Tarde 3",
	EVENING4: "Tarde 4",
	FULL: "Integral",
	FULL1: "Integral 1",
	FULL2: "Integral 2",
	FULL3: "Integral 3",
	FULL4: "Integral 4",
	MORNING: "Manhã",
	MORNING1: "Manhã 1",
	MORNING2: "Manhã 2",
	MORNING3: "Manhã 3",
	MORNING4: "Manhã 4",
	NIGHT: "Noite",
	NIGHT1: "Noite 1",
	NIGHT2: "Noite 2",
	NIGHT3: "Noite 3",
	NIGHT4: "Noite 4",
	OTHER: "Outro",
	VIRTUAL: "Virtual",
	WEEKEND: "Fim de semana",
};

export const classTypeLabels: { [key: string]: string } = {
	FLEX: "Semipresencial (Flex)",
	INCLASS: "Presencial",
	INCLASS_FLEX: "Presencial Flex",
	LIVE: "Live",
	MIXED: "Semipresencial",
	ONLINE: "EaD",
	PREMIUM_MIXED: "Semipresencial Premium",
};

export const formatNumberToStringCurrency = (value: number) => {
	return (
		"R$ " +
		(value / 100).toLocaleString("pt-BR", {
			maximumFractionDigits: 2,
			minimumFractionDigits: 2,
		})
	);
};

export const formatStringCurrencyNoPrefix = (value: number) => {
	return (value / 100).toLocaleString("pt-BR", {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2,
	});
};

export const getClassDescPagePath = (institutionSlug: string, courseSlug: string, classId?: string) => {
	if (classId) {
		return `${institutionSlug}/cursos/${courseSlug}/${classId}`;
	}

	return `${institutionSlug}/cursos/${courseSlug}`;
};

export const formatDuration = (duration?: number, durationType?: DurationType): string => {
	if (duration === 1) {
		if (durationType === "Meses") {
			return "Mês";
		} else if (durationType === "Horas") {
			return "Hora";
		}
		return "Semestre";
	}
	return durationType || "-";
};

export const graduationTypeLabels: { [key: string]: string } = {
	Bacharelado: "Bacharelado",
	CursosLivres: "Curso Livre",
	Licenciatura: "Licenciatura",
	Posgraduacao: "Pós-Graduação",
	Tecnologo: "Tecnólogo",
};

export const levelLabels: { [key: string]: string } = {
	CursosLivres: "Curso Livre",
	Graduacao: "Graduação",
	Posgraduacao: "Pós-graduação",
};
